import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Validators from '../../utils/Validators';
import Formatter from '../../utils/Formatter';
import {connect} from 'react-redux';
import {showError} from '../../actions/uiActions';

class ServicerAddress extends Component
{
    state={
        name:"",
        phone:"",
        email:"",
        address1:"",
        address2:"",
        city:"",
        state:"",
        zip:""

    }
    handleInputChange=(e)=>{
        this.setState({[e.target.name]:e.target.value})
    }
    handleInfoChange=(e,index,field)=>{
        this.setState({officials:this.state.officials.map((official,i)=>{
            if(i==index)
                official[field]=e.target.value;
            return official;
        })})
    }
    confirm=()=>{
        if(!this.state.name)
            this.props.showError("Please enter the name of the servicer");
        else if(!this.state.address1)
            this.props.showError("Please enter the address of the servicer");
        else if(!this.state.city)
            this.props.showError("Please enter the city of the servicer");
        else if(!this.state.state)
            this.props.showError("Please enter the state of the servicer");
        else if(!this.state.zip)
            this.props.showError("Please enter the Zip Code of the servicer");
        else if(!Validators.isValidEmail(this.state.email))
            this.props.showError("Please enter the email address of the servicer");
        else if(!this.state.phone)
            this.props.showError("Please enter the phone number of the servicer");
        else
            this.props.onConfirm(this.state);
    }
    componentWillMount()
    {
        
        if(this.props.form.servicer)
        {
            let servicer=Formatter.getServicer(this.props.form.servicer,this.props.account.msd.details);
            if(servicer)
            {
                this.setState({
                    name:servicer.loan_contact_name,
                    address1:servicer.loan_contact_address1,
                    address2:servicer.loan_contact_address2,
                    city:servicer.loan_contact_city,
                    state:servicer.loan_contact_state,
                    zip:servicer.loan_contact_zip,
                    phone:servicer.loan_contact_phone,
                    email:servicer.loan_contact_email
                })
            }
        }
        
    }
    render()
    {
        
        return <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" open={true}
        maxWidth="sm" fullWidth={true}
        >
        <DialogTitle id="alert-dialog-title">Servicer Address</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
                Please enter the mailing address of the Servicer where where this form is going to be sent to.
            </p>
            
            <div className="row">
                <div className="col-12">
                    <div className="form-group nice">
                        <label>Servicer Name:</label>
                        <input type="text" placeholder="Name of the Loan Servicer" className="form-control" value={this.state.name} onChange={this.handleInputChange} name="name" />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group nice">
                        <label>Address Line 1:</label>
                        <input type="text" placeholder="Address Line 1" className="form-control" value={this.state.address1} onChange={this.handleInputChange} name="address1" />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group nice">
                        <label>Address Line 2:</label>
                        <input type="text" placeholder="Address Line 2" className="form-control" value={this.state.address2} onChange={this.handleInputChange} name="address2" />
                    </div>
                </div>
                <div className="col-4">
                    <div className="form-group nice">
                        <label>City:</label>
                        <input type="text" placeholder="City" className="form-control" value={this.state.city} onChange={this.handleInputChange} name="city" />
                    </div>
                </div>
                <div className="col-4">
                    <div className="form-group nice">
                        <label>State:</label>
                        <input type="text" placeholder="State" className="form-control" value={this.state.state} onChange={this.handleInputChange} name="state" />
                    </div>
                </div>
                <div className="col-4">
                    <div className="form-group nice">
                        <label>Zip Code:</label>
                        <input type="text" placeholder="Zip Code" className="form-control" value={this.state.zip} onChange={this.handleInputChange} name="zip" />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group nice">
                        <label>Email Address:</label>
                        <input type="email" placeholder="Servicer's Email Address" className="form-control" value={this.state.email} onChange={this.handleInputChange} name="email" />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group nice">
                        <label>Phone Number:</label>
                        <input type="tel" placeholder="Servicer's Phone" className="form-control" value={this.state.phone} onChange={this.handleInputChange} name="phone" />
                    </div>
                </div>
                
            </div>
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={this.confirm} color="primary" autoFocus>
            Submit Form
          </Button>
          <Button onClick={this.props.onCancel} color="primary">
            Cancel
          </Button>
        </DialogActions>
        </Dialog>
    }
}
export default connect(null,{showError})(ServicerAddress);